<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">
        
        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Settings</h3>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Settings Tabs -->
        <ul class="nav nav-tabs menu-tabs">
          <li class="nav-item active">
            <router-link class="nav-link" to="/settings/profile">
              <i class="fas fa-user mr-2"></i>Profile
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/settings/security">
              <i class="fas fa-lock mr-2"></i>Security
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/settings/preferences">
              <i class="fas fa-bell mr-2"></i>Preferences
            </router-link>
          </li>
        </ul>

        <!-- Profile Form -->
        <div class="row">
          <div class="col-lg-9">
            <ContactDetailsForm
              v-if="customer && customer.id"
              :customer="customer"
              :show-personal-details-header="true"
              basic-details-card-title="Personal Information"
              :show-id-number="isMedicalLocale"
              :show-gender="isMedicalLocale"
              :show-date-of-birth="isMedicalLocale"
              :show-contact-addresses="isMedicalLocale"
              :use-direct-endpoint="false"
              :show-metadata="false"
              :max-phones="3"
              :max-emails="3"
              :max-addresses="isMedicalLocale ? 1 : 0"
              @customer-updated="handleCustomerUpdated"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import contactService from "../../service/contact.service";
import ContactDetailsForm from "../ContactDetails/ContactDetailsForm.vue";

export default {
  name: "profile-settings",
  components: {
    ContactDetailsForm
  },
  data() {
    return {
      customer: {},
      contextId: null,
      customerId: null
    };
  },
  computed: {
    isMedicalLocale() {
      return process.env.ACTIVE_LOCALE === 'medical';
    }
  },
  mounted() {
    this.retrieveUser();
    this.retrieveCustomer();
  },
  methods: {
    retrieveUser() {
      this.contextId = localStorage.getItem('contextId') || localStorage.getItem('selectedContextId');
      this.customerId = localStorage.getItem('actorId');
    },

    retrieveCustomer() {
      if (!this.contextId || !this.customerId) {
        console.error('Missing context ID or customer ID');
        return;
      }

      contactService.findById(this.contextId, this.customerId)
        .then(response => {
          if (response.data.code === 'SUCCESS') {
            this.customer = response.data.data;
          }
        })
        .catch(error => {
          console.error('Error retrieving customer:', error);
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Failed to load profile information'
          });
        });
    },

    handleCustomerUpdated(updatedCustomer) {
      this.customer = updatedCustomer;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/settings/ProfileSettings.vue